export default {
    //baseInfo
    baseInfo: {
    },
    lotteryDrawTime: {
    },
}
